module.exports = __webpack_public_path__ + "static/media/7.8bd64e18.jpg";